var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 551.02 559.75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls2{fill:#00aeef;}.cls1{fill:#231f20;}.cls3{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:30px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls1",
    cx: 88.65,
    cy: 88.65,
    r: 88.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls1",
    cx: 88.65,
    cy: 279.87,
    r: 88.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls2",
    cx: 462.37,
    cy: 281.43,
    r: 88.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls1",
    cx: 88.65,
    cy: 471.1,
    r: 88.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.87,307c2.06-4.32,4.07-8.65,6.18-12.94.71-1.44.77-2.07-1.18-2.05-8.83.05-17.65,0-26.48,0-1.26,0-2.52,0-3.78-.15a11.1,11.1,0,0,1-9.81-7.32c-1.77-4.49-1.27-8.78,1.9-12.5,2.62-3.08,6.19-4.17,10.15-4.18,9.76,0,19.51-.09,29.27-.08,1.42,0,1.91-.1,1.18-1.68-4.22-9.16-8.34-18.37-12.48-27.56a25.31,25.31,0,0,1-1.12-2.76,7.1,7.1,0,0,1,8-9.38,11.07,11.07,0,0,1,3.2,1.07L351,273.68c4,1.88,5.74,4.94,5,8.52a7.64,7.64,0,0,1-4.9,5.61q-17.76,7.56-35.54,15.09l-45.81,19.42c-5.68,2.41-11.38,4.78-17.06,7.2a7.56,7.56,0,0,1-7.25-.22c-3.37-2.06-4.43-5.63-2.73-9.35,2-4.34,4.1-8.64,6.15-12.95Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls3",
    x1: 38.19,
    x2: 336.46,
    y1: 279.87,
    y2: 279.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,412.06c0-4.78,0-9.56.14-14.34,0-1.6-.18-2.2-1.95-1.36-8,3.78-16,7.47-24,11.17a36.8,36.8,0,0,1-3.49,1.47,11.1,11.1,0,0,1-12-2.49c-3.51-3.32-4.87-7.43-3.57-12.14,1.08-3.9,3.85-6.39,7.44-8.07,8.83-4.15,17.64-8.33,26.49-12.44,1.29-.6,1.69-.9.36-2-7.69-6.52-15.32-13.12-23-19.7a26.18,26.18,0,0,1-2.18-2,7.1,7.1,0,0,1,3.31-11.9,11.16,11.16,0,0,1,3.35-.37l107.54.86c4.39,0,7.28,2.06,8.13,5.61a7.62,7.62,0,0,1-2.07,7.15q-12.9,14.37-25.84,28.7l-33.3,37c-4.14,4.58-8.3,9.14-12.42,13.73a7.58,7.58,0,0,1-6.67,2.86c-3.93-.44-6.39-3.23-6.42-7.32,0-4.78.06-9.56.1-14.33Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls3",
    x1: 67.34,
    x2: 337.66,
    y1: 476.51,
    y2: 350.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.36,193c3.68-3,7.34-6.12,11.06-9.11,1.26-1,1.57-1.55-.2-2.37-8-3.67-16-7.45-24-11.2-1.14-.54-2.28-1.08-3.36-1.73a11.1,11.1,0,0,1-5.8-10.78c.29-4.82,2.56-8.5,7-10.53,3.67-1.69,7.37-1.16,11,.5,8.86,4.1,17.72,8.17,26.56,12.3,1.29.6,1.77.72,1.78-1,.05-10.08.21-20.16.33-30.25a26.74,26.74,0,0,1,.16-3,7.09,7.09,0,0,1,11.24-5.11,11,11,0,0,1,2.44,2.32q34.23,41.47,68.47,82.93c2.79,3.39,3.1,6.91.92,9.84a7.62,7.62,0,0,1-6.8,3q-19.31-.66-38.59-1.35l-49.73-1.75c-6.17-.22-12.34-.48-18.5-.69a7.53,7.53,0,0,1-6.48-3.26c-2.19-3.29-1.63-7,1.48-9.63,3.64-3.09,7.36-6.09,11-9.14Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls3",
    x1: 65.88,
    x2: 336.2,
    y1: 79.35,
    y2: 205.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.91ef3990badce508f9643272b6030b42.svg";
export { ForwardRef as ReactComponent };